import React from 'react';

const BookIcon = ({ stroke = "white", className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style: { ...style, overflow: "visible" }
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8 12.6667C7.08788 12.1401 6.05322 11.8628 5 11.8628C3.94678 11.8628 2.91212 12.1401 2 12.6667V4.00001C2.91212 3.4734 3.94678 3.19617 5 3.19617C6.05322 3.19617 7.08788 3.4734 8 4.00001M8 12.6667C8.91212 12.1401 9.94678 11.8628 11 11.8628C12.0532 11.8628 13.0879 12.1401 14 12.6667V4.00001C13.0879 3.4734 12.0532 3.19617 11 3.19617C9.94678 3.19617 8.91212 3.4734 8 4.00001M8 12.6667V4.00001",
      stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
BookIcon.displayName = "Icons.BookIcon";

export { BookIcon };
//# sourceMappingURL=BookIcon.js.map
